import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  expireDate: null,
  renewValue: null,
  isLoading: false,
  error: "",
};

export const SubscriptionExpirySlice = createSlice({
  name: "SubscriptionExpiry",
  initialState,
  reducers: {
    setSubscriptionExpiry: (state, action) => {
      state.expireDate = action.payload.expiration_date;
      state.renewValue = action.payload.value;
    },
    clearSubscriptionExpiryData: (state) => {
      state.expireDate = null;
      state.renewValue = null;
      state.error = null;
      state.isLoading = false;
    },
    catchError: (state, action) => {
      state.error = action.payload;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
  },
});

export const {
  setSubscriptionExpiry,
  clearSubscriptionExpiryData,
  catchError,
  setLoading,
} = SubscriptionExpirySlice.actions;
export default SubscriptionExpirySlice.reducer;
